class ProductForm extends HTMLElement {
  connectedCallback() {
    this.form         = this.querySelector('[data-add-form]');
    this.variantInput = this.querySelector('[data-variant-input]');
    this.addBtn       = this.querySelector('[data-add-btn]');
    this.addLabel     = this.querySelector('[data-add-label]');
    this.priceMain    = this.querySelector('[data-price-main]');
    this.options      = this.querySelectorAll('.variant-option');
    this.defaultLabel = this.addLabel ? this.addLabel.textContent : 'Add to Setup';

    this.options.forEach((btn) => {
      btn.addEventListener('click', () => {
        if (!btn.classList.contains('sold-out')) this.selectVariant(btn);
      });
    });

    if (this.form) this.form.addEventListener('submit', (e) => this.addToCart(e));
  }

 selectVariant(btn) {
    this.options.forEach((b) => { b.classList.remove('active'); b.setAttribute('aria-checked', 'false'); });
    btn.classList.add('active');
    btn.setAttribute('aria-checked', 'true');
    this.variantInput.value = btn.dataset.variantId;
    this.priceMain.textContent = this.formatMoney(parseInt(btn.dataset.price, 10));

    // Bild passend zur Variante einblenden
    const images = document.querySelectorAll('.product-variant-image');
    images.forEach((img) => {
      img.classList.toggle('active', img.dataset.variantId === btn.dataset.variantId);
    });
  }

  async addToCart(e) {
    e.preventDefault();
    this.addBtn.disabled = true;
    this.addLabel.textContent = '…';
    try {
      await fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ items: [{ id: this.variantInput.value, quantity: 1 }] }),
      });
      const cart = await (await fetch('/cart.js')).json();
      document.dispatchEvent(new CustomEvent('onyx:cart-updated', { detail: { count: cart.item_count } }));
      this.addLabel.textContent = '✓ Added';
      setTimeout(() => { this.addLabel.textContent = this.defaultLabel; this.addBtn.disabled = false; }, 1500);
    } catch (err) {
      console.error(err);
      this.addLabel.textContent = 'Fehler – nochmal';
      this.addBtn.disabled = false;
    }
  }

  formatMoney(cents) {
    if (window.Shopify && Shopify.formatMoney) return Shopify.formatMoney(cents, window.moneyFormat);
    return '€' + (cents / 100).toFixed(2).replace('.', ',');
  }
}
customElements.define('product-form', ProductForm);
